import { render, staticRenderFns } from "./LayoutDark.vue?vue&type=template&id=dd8c6e4a&scoped=true"
import script from "./LayoutDark.vue?vue&type=script&lang=js"
export * from "./LayoutDark.vue?vue&type=script&lang=js"
import style0 from "./LayoutDark.vue?vue&type=style&index=0&id=dd8c6e4a&prod&lang=scss&scoped=true"
import style1 from "./LayoutDark.vue?vue&type=style&index=1&id=dd8c6e4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd8c6e4a",
  null
  
)

export default component.exports